import type { PermissionSelector } from "@/hooks/usePermission";

export const canListProjectConnections: PermissionSelector = (p) => p.isSuperAdmin;

export const canManageProjectConnections: PermissionSelector = (p) => p.isSuperAdmin;

export const canListProjectConnectionGroups: PermissionSelector = (p) => p.isSuperAdmin;

export const canManageProjectConnectionGroups: PermissionSelector = (p) => p.isSuperAdmin;
